<template>
  <v-container fluid>

    <v-row>
      <v-col cols="12" sm="6" md="3">
        <v-card class="dashboard-card total-card" elevation="6">
          <v-card-text>
            <div class="card-title">Total</div>
            <div class="card-number">{{ resumen.Total }}</div>
            <v-icon class="card-icon">mdi-truck</v-icon>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card class="dashboard-card pendiente-card" elevation="6">
          <v-card-text>
            <div class="card-title">Pendientes</div>
            <div class="card-number">{{ resumen.Pendientes }}</div>
            <v-icon class="card-icon">mdi-clock-alert</v-icon>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card class="dashboard-card proceso-card" elevation="6">
          <v-card-text>
            <div class="card-title">En proceso</div>
            <div class="card-number">{{ resumen.EnProceso }}</div>
            <v-icon class="card-icon">mdi-progress-clock</v-icon>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card class="dashboard-card concluido-card" elevation="6">
          <v-card-text>
            <div class="card-title">Concluidos</div>
            <div class="card-number">{{ resumen.Concluidos }}</div>
            <v-icon class="card-icon">mdi-check-circle</v-icon>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-4">
      <v-col cols="12" md="8">
        <v-card elevation="4" class="pa-4">
          <h3>Cargas por mes</h3>

          <div class="bar-chart">
            <div
              v-for="item in cargasPorMes"
              :key="item.mes"
              class="bar-item"
            >
              <div class="bar-label">{{ item.mes }}</div>
              <div class="bar-track">
                <div
                  class="bar-fill"
                  :style="{ width: item.porcentaje + '%' }"
                >
                  {{ item.total }}
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card elevation="4" class="pa-4 supervisor-card">
          <h3>Supervisoras</h3>

          <div class="supervisor-number">
            {{ totalSupervisoras }}
          </div>

          <div class="supervisor-text">
            Supervisoras registradas en carga
          </div>

          <v-icon size="70" color="primary">
            mdi-account-group
          </v-icon>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
export default {
  name: 'DashboardCarga',

  data() {
    return {
      resumen: {
        Total: 4,
        Pendientes: 3,
        EnProceso: 1,
        Concluidos: 0
      },

      cargasPorMes: [
        { mes: 'Enero', total: 12, porcentaje: 60 },
        { mes: 'Febrero', total: 18, porcentaje: 90 },
        { mes: 'Marzo', total: 9, porcentaje: 45 },
        { mes: 'Abril', total: 20, porcentaje: 100 }
      ],

      totalSupervisoras: 5
    }
  }
}
</script>

<style scoped>
.dashboard-card {
  height: 130px;
  border-radius: 18px;
  color: white;
  position: relative;
  overflow: hidden;
}

.total-card {
  background: linear-gradient(135deg, #1976d2, #0d47a1);
}

.pendiente-card {
  background: linear-gradient(135deg, #f44336, #b71c1c);
}

.proceso-card {
  background: linear-gradient(135deg, #ffc107, #ff8f00);
  color: #222;
}

.concluido-card {
  background: linear-gradient(135deg, #4caf50, #1b5e20);
}

.card-title {
  font-size: 15px;
  font-weight: 600;
}

.card-number {
  font-size: 42px;
  font-weight: bold;
  margin-top: 8px;
}

.card-icon {
  position: absolute;
  right: 18px;
  bottom: 14px;
  font-size: 52px;
  opacity: 0.35;
}

.bar-chart {
  margin-top: 20px;
}

.bar-item {
  margin-bottom: 16px;
}

.bar-label {
  font-weight: 600;
  margin-bottom: 5px;
}

.bar-track {
  height: 28px;
  background: #eeeeee;
  border-radius: 20px;
  overflow: hidden;
}

.bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #1976d2, #42a5f5);
  color: white;
  font-weight: bold;
  text-align: right;
  padding-right: 12px;
  line-height: 28px;
  border-radius: 20px;
}

.supervisor-card {
  border-radius: 18px;
  text-align: center;
  min-height: 250px;
}

.supervisor-number {
  font-size: 60px;
  font-weight: bold;
  color: #1976d2;
  margin-top: 20px;
}

.supervisor-text {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}
</style>